import { useRef} from 'react'
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';

var settings16 = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1400,
    autoplaySpeed: 4000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    pauseOnHover: false,
    cssEase: "ease",
    responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
          },
        },

        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            autoplay: true,
          },
        },
  
        {
          breakpoint: 599,
          settings: {
            slidesToShow: 1,
            autoplay: true,
          },
        },
      ],
};

export default function ServicesOther({relatedProjects}) {
    const sliderRef = useRef(null);

    const CustomArrows = () => (
        <div className="otherproj-arrows">
            <div className="default-arrowleft" onClick={() => sliderRef.current && sliderRef.current.slickPrev()}>
                <FontAwesomeIcon icon={faArrowLeft} />
            </div>
            <div className="default-arrowright" onClick={() => sliderRef.current && sliderRef.current.slickNext()}>
                <FontAwesomeIcon icon={faArrowRight} />
            </div>
        </div>
    );

  return (
    <>
    <section className="other-service">
        <div className="container">
            <div className="row">

                <div className='col-lg-12'>
                    <div className='vector-heading'>
                        <img src="./assets/home/shape-vector.png" alt="vector"/>
                        <h4 className='heading'>related projects</h4>
                    </div>
                </div>

                <div className='col-lg-12'>
                    <Slider className="portfolio-slider" ref={sliderRef} {...settings16}>
                    {relatedProjects.map((project, index) => (
                        <div className='portfolio-slidebox' key={index}>
                             <Link to={`/project/${project.slug.current}`}>
                                <div>
                                    <img src={project.imageUrl} className='img-responsive' alt="project" loading="lazy"/>
                                    <img src="/assets/home/light-curve.svg" className='port-curve-1' alt="shape" loading="lazy"/>
                                    <img src="/assets/home/white-curve.svg" className='port-curve-2' alt="shape" loading="lazy"/>
                                </div>
                                <h4>{project.title}</h4>
                                <span>{project.category?.title} • {project.city} </span>
                            </Link>
                        </div>
                    ))}

                        {/* <div className='portfolio-slidebox'>
                            <Link to={""}>
                                <div>
                                    <img src="./assets/home/portfolio-1.webp" className='img-responsive' alt="project"/>
                                    <img src="/assets/home/light-curve.svg" className='port-curve-1' alt="shape"/>
                                    <img src="/assets/home/white-curve.svg" className='port-curve-2' alt="shape"/>
                                </div>
                                <h4>Project Name</h4>
                                <span>residential • new delhi </span>
                            </Link>
                        </div>

                        <div className='portfolio-slidebox'>
                            <Link to={""}>
                                <div>
                                    <img src="./assets/home/portfolio-1.webp" className='img-responsive' alt="project"/>
                                    <img src="/assets/home/light-curve.svg" className='port-curve-1' alt="shape"/>
                                    <img src="/assets/home/white-curve.svg" className='port-curve-2' alt="shape"/>
                                </div>
                                <h4>Project Name</h4>
                                <span>residential • new delhi </span>
                            </Link>
                        </div> */}
                    </Slider>

                    <CustomArrows />
                </div>

                {/* {services.map((service, index) => (
                    <div className='col-lg-4 col-md-4'  key={index}>
                        <div className='service-box servicepage-box'>
                            <Link  to={`/services/${service.slug}`}>
                                <img src={service.imageUrl}
                                className='img-responsive' alt="project"/>
                                <img src="/assets/home/light-curve.svg" className='servicedetail-curve' alt="shape"/>
                                <div>
                                    <h4>{service.title}</h4>
                                    <span>explore</span>
                                </div>
                            </Link>
                        </div>
                    </div>
                ))} */}

            </div>
        </div>
    </section>
    </>
  )
}
